export const appStateModules = {
    report: 'report',
    portfolio: 'portfolio',
    exports: 'exports',
}

export const GET_APP_STATE = 'GET_APP_STATE'
export const GET_APP_STATE_REQUEST = 'GET_APP_STATE_REQUEST'
export const POST_APP_STATE = 'POST_APP_STATE'
export const POST_APP_STATE_REQUEST = 'POST_APP_STATE_REQUEST'
export const SET_NEW_APP_STATE = 'SET_NEW_APP_STATE'
export const UPDATE_APP_STATE = 'UPDATE_APP_STATE'
